import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import { IconCheck } from "theme/common/Icon.styled"
import { IPickupReservaAction } from "interfaces/IShippingGroupAction"

const PickupReservaAction = ({ loadingPickupReserva, onClickPickupReserva }: IPickupReservaAction) => {
  return (
    <ContentDetailOrderActionsStyled>
      <ButtonStyled
        variant="primary"
        loadingButton={loadingPickupReserva}
        disabled={loadingPickupReserva}
        onClick={onClickPickupReserva}
      >
        <IconCheck />
        <span>Confirmar Retiro</span>
      </ButtonStyled>
    </ContentDetailOrderActionsStyled>
  )
}

export default PickupReservaAction
